import { render, staticRenderFns } from "./FluidCover.vue?vue&type=template&id=20da8b28&scoped=true&"
import script from "./FluidCover.vue?vue&type=script&lang=js&"
export * from "./FluidCover.vue?vue&type=script&lang=js&"
import style0 from "./FluidCover.vue?vue&type=style&index=0&id=20da8b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20da8b28",
  null
  
)

export default component.exports